<template>
	<div class="page">
		<el-row>
		  <el-col :xs="0" :sm="20" :md="20" :lg="20" :xl="20" :offset="2">
			  <div class="grid-content release">
				  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				    <el-form-item label="招标标题" prop="title">
				      <el-input v-model="ruleForm.title"  placeholder="请输入标题"></el-input>
				    </el-form-item>
				    <el-form-item label="招标类型" prop="typelist">
				      <el-select v-model="ruleForm.typelist" placeholder="请选择招标类型">
				        <el-option label="招标公告" value="0"></el-option>
				        <el-option label="散单需求" value="1"></el-option>
				      </el-select>
				    </el-form-item>
				    <el-form-item label="开始时间" required>
				      <el-col :span="11">
				        <el-form-item prop="startdate">
				          <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.startdate" style="width: 100%;"></el-date-picker>
				        </el-form-item>
				      </el-col>
				    </el-form-item>
					<el-form-item label="结束时间" required>
					  <el-col :span="11">
					    <el-form-item prop="enddate">
					      <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.enddate" style="width: 100%;"></el-date-picker>
					    </el-form-item>
					  </el-col>
					</el-form-item>
					<el-form-item label="所属行业" prop="hangyelist">
					  <el-select v-model="ruleForm.hangyelist" placeholder="请选择所属行业">
					    <el-option :label="item.name" :value="item.Id" v-for="item in hangyelist"></el-option>
					  </el-select>
					</el-form-item>
					<el-form-item label="省份" prop="province">
					  <el-select v-model="ruleForm.province" placeholder="请选择所属省份">
					    <el-option :label="item.name" :value="item.Id" v-for="item in province"></el-option>
					  </el-select>
					</el-form-item>
					<el-form-item label="招标文件" prop="fileupload">
						<el-upload
						  ref="myFile"
						  :action="this.$utils.upload"
						  :headers="headers"
						  :class="{hide:hideUpload}"
						  accept=".doc,.docx"
						  list-type="picture-card"
						  :on-success="handleSuccess"
						  :on-change = "toHideUpload"
						  :limit="1"
						  :auto-upload="true">
							<i slot="default" class="el-icon-plus"></i>
							<div slot="file" slot-scope="{file}">
							  <img
								class="el-upload-list__item-thumbnail"
								src="/images/docment-icon.jpg" width="50%" alt=""
							  >
							  <span class="el-upload-list__item-actions">
								<span
								  v-if="!disabled"
								  class="el-upload-list__item-delete"
								  @click="clearFiles"
								>
								  <i class="el-icon-delete"></i>
								</span>
							  </span>
							</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="详细内容" prop="details">
						<editor v-model="ruleForm.noticeContent" :min-height="380" /> 
					</el-form-item>
				    <el-form-item>
				      <el-button type="primary" @click="submitForm('ruleForm')">确认提交</el-button>
				    </el-form-item>
				  </el-form>
			  </div>
		  </el-col>
		  <!-- 手机端 -->
		<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0" style="margin:0 -19px;width:110%">
		  <div class="grid-content release">
			  <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="招标标题" prop="title">
				  <el-input v-model="ruleForm.title"  placeholder="请输入标题"></el-input>
				</el-form-item>
				<el-form-item label="招标类型" prop="typelist">
				  <el-select v-model="ruleForm.typelist" placeholder="请选择招标类型">
					<el-option label="招标公告" value="0"></el-option>
					<el-option label="散单需求" value="1"></el-option>
				  </el-select>
				</el-form-item>
				<el-form-item label="开始时间" required>
				  <el-col :span="11">
					<el-form-item prop="startdate">
					  <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.startdate" style="width: 100%;"></el-date-picker>
					</el-form-item>
				  </el-col>
				</el-form-item>
				<el-form-item label="结束时间" required>
				  <el-col :span="11">
					<el-form-item prop="enddate">
					  <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.enddate" style="width: 100%;"></el-date-picker>
					</el-form-item>
				  </el-col>
				</el-form-item>
					</el-form-item>
					<el-form-item label="所属行业" prop="hangyelist">
					  <el-select v-model="ruleForm.hangyelist" placeholder="请选择所属行业">
					    <el-option :label="item.name" :value="item.Id" v-for="item in hangyelist"></el-option>
					  </el-select>
					</el-form-item>
					<el-form-item label="省份" prop="province">
					  <el-select v-model="ruleForm.province" placeholder="请选择所属省份">
					    <el-option :label="item.name" :value="item.Id" v-for="item in province"></el-option>
					  </el-select>
					</el-form-item>
				<el-form-item label="招标文件" prop="fileupload">
						<el-upload
						  ref="myFile"
						  :action="this.$utils.upload"
						  :headers="headers"
						  :class="{hide:hideUpload}"
						  accept=".doc,.docx"
						  list-type="picture-card"
						  :on-success="handleSuccess"
						  :on-change = "toHideUpload"
						  :limit="1"
						  :auto-upload="true">
							<i slot="default" class="el-icon-plus"></i>
							<div slot="file" slot-scope="{file}">
							  <img
								class="el-upload-list__item-thumbnail"
								src="/images/docment-icon.jpg" width="50%" alt=""
							  >
							  <span class="el-upload-list__item-actions">
								<span
								  v-if="!disabled"
								  class="el-upload-list__item-delete"
								  @click="clearFiles"
								>
								  <i class="el-icon-delete"></i>
								</span>
							  </span>
							</div>
						</el-upload>

				</el-form-item>
				<el-form-item label="详细内容" prop="details">
					<editor v-model="form.noticeContent" :min-height="190"/> 
				</el-form-item> 
				<el-form-item>
				  <el-button type="primary" @click="submitForm('ruleForm')" style="width:100%;text-align: center;">确认提交</el-button>
				</el-form-item>
			  </el-form>
		  </div>
		</el-col>
		</el-row>

	</div>
</template>
<script>
  export default {
	metaInfo() {
	  return {
		title: '发布项目 - ' + this.metaName,
		meta: [
		  { charset: "utf-8" },
		  { name: "keywords", content: this.metaKeywords },
		  { name: "description", content: this.metaDecs },
		],
	  };
	},
    data() {
      return {
		metaName: "",
		metaKeywords: "",
		metaDecs: "",
		form:{
			noticeContent:'',
			mobilenoticeContent:''
		},
		province: [],
		hangyelist:[],
		startdate:'',
		enddate:'',
		dialogImageUrl: '/images/docment-icon.jpg',
		dialogVisible: false,
		disabled: false,
		hideUpload: false,
		headers:{'token':window.localStorage.getItem('token')},
        ruleForm: {
		  user_id:0,
          title: '',
		  province: '',
		  hangyelist:'',
		  startdate:'',
		  enddate:'',
		  file:'',
		  noticeContent:'',
        },
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' },
            { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
          ],
          province: [
            { required: true, message: '请选择省份', trigger: 'change' }
          ],
		  hangyelist: [
		    { required: true, message: '请选择行业', trigger: 'change' }
		  ],
		  typelist: [
		    { required: true, message: '请选择类型', trigger: 'change' }
		  ],
          startdate: [
            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
          ],
          enddate: [
            { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
          ]
        }
      };
    },
	mounted() {
		window.scrollTo(0,0);
		this.$axios({
			url:this.$utils.httpApi + 'index/webconfig'
		}).then(res=>{
			this.metaName = res.data.data.webtitle
			this.metaDecs = res.data.data.webdescription
			this.metaKeywords = res.data.data.webkeywords
		})
		if(window.localStorage.getItem("token")){
			this.$axios({
				url:this.$utils.httpApi + 'user/getinfos',
				headers:{
					'token':window.localStorage.getItem("token")
				}
			}).then(res=>{
				this.ruleForm.user_id = res.data.id
			})	
		}
	},
	created() {
		this.getProvince();
		this.getHangyeList();
	},
    methods: {
		handleSuccess(res,file){
			this.ruleForm.file = res.data.fullurl
		},
		toHideUpload(file,fileList){
			this.hideUpload = fileList.length >= 1
		},	
		getProvince(){
			this.$axios({
				url:this.$utils.httpApi + 'getinfo/province',
			}).then(res=>{
				this.province = res.data.data
			})
		},
		getHangyeList(){
			this.$axios({
				url:this.$utils.httpApi + 'getInfo/hangye',
			}).then(res=>{
				this.hangyelist = res.data.data
			})
		},
      submitForm(formName) {
		if(this.ruleForm.user_id == 0){
			  this.$message({
				  message:'请先登录！',
				  type:'error'
			  })
			  this.$router.push('/')
		}else{
			this.$refs[formName].validate((valid) => {
			  if (valid) {
			    console.log(this.ruleForm)
				this.$axios({
					url:this.$utils.httpApi + 'release',
					data:this.ruleForm,
					headers:this.headers,
					method:'post'
				}).then(res=>{
					if(res.data.code == 1){
						this.$message({
							message:res.data.msg,
							type:'success'
						})
						this.$router.push('/usercenter/managezb')
					}else{
						this.$message({
							message:res.data.msg,
							type:'error'
						})
					}

				})
			  } else {
			    return false;
			  }
			});
		}

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
	clearFiles () {
		  this.$refs['myFile'].clearFiles();
		  this.hideUpload = false
	  }
    }
  }
</script>

<style>
	.hide .el-upload--picture-card {
		display: none;
	}

	  .none{
		  display: none;
	  }
	  .el-col {
	    border-radius: 4px;
	  }
	  .bg-purple-dark {
	    background: #99a9bf;
	  }
	  .bg-purple {
	    background: #d3dce6;
	  }
	  .bg-purple-light {
	    background: #e5e9f2;
	  }
	  .grid-content {
	    border-radius: 4px;
	    min-height: 36px;
	  }
</style>